import { Space, Statistic, Typography } from 'antd'
import { useEffect, useState } from 'react'
import { Platform } from '../../models/Platform'
import { fetchVersionForPlatform } from '../../services/PlatformService'

const { Text } = Typography

interface Props {
  platform: Platform
  identifier?: string
}

export const PlatformCard = ({ platform, identifier }: Props) => {
  const [version, setVersion] = useState<string>('--')
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    if (identifier === undefined) return
    setIsLoading(true)
    fetchVersionForPlatform(platform.slug, identifier)
      .then((result) => setVersion(result.version ?? '--'))
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  return (
    <Space orientation="vertical">
      <Statistic
        loading={isLoading}
        title={<Space>{platform.name}</Space>}
        value={version}
      />
      <Text type="secondary">{identifier}</Text>
    </Space>
  )
}

export type PlatformCardType = { Card: typeof PlatformCard }
